import { render, staticRenderFns } from "./SearchOnEnter.vue?vue&type=template&id=1b954e1e&"
import script from "./SearchOnEnter.vue?vue&type=script&lang=js&"
export * from "./SearchOnEnter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b954e1e')) {
      api.createRecord('1b954e1e', component.options)
    } else {
      api.reload('1b954e1e', component.options)
    }
    module.hot.accept("./SearchOnEnter.vue?vue&type=template&id=1b954e1e&", function () {
      api.rerender('1b954e1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/SearchOnEnter.vue"
export default component.exports